import ReactDOM from 'react-dom/client'
import '/node_modules/react-grid-layout/css/styles.css'
import '/node_modules/react-resizable/css/styles.css'
import './App.scss'
import App from "./App.tsx"
import { defaultQueryFn } from "./api/defaultQuery.ts"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

const queryClient = new QueryClient()

queryClient.setDefaultOptions({
    queries: {
        queryFn: defaultQueryFn,
        staleTime: Infinity,
    },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
    <QueryClientProvider client={queryClient}>
        <App/>
    </QueryClientProvider>
)
